var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbibank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4146 1.18359C10.6893 1.18359 1.18408 10.7109 1.18408 22.463C1.18408 33.4809 9.5383 42.5425 20.242 43.632V28.1741C17.9415 27.2962 16.3025 25.0683 16.3025 22.463C16.3025 19.092 19.0436 16.3494 22.4146 16.3494C25.7841 16.3494 28.5283 19.092 28.5283 22.463C28.5283 25.0683 26.8862 27.2962 24.5857 28.1741V43.632C35.2909 42.5425 43.6451 33.4809 43.6451 22.463C43.6451 10.7109 34.1399 1.18359 22.4146 1.18359Z",
    fill: "#00B5EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbibank);
export default __webpack_public_path__ + "static/media/sbibank.0b9f2af6cc5f0e959684d8ec695a0a4a.svg";
export { ForwardRef as ReactComponent };